import React from "react";
import { MdClose } from "@react-icons/all-files/md/MdClose";
import { MdVolumeUp as MdVolumeUpIcon } from "@react-icons/all-files/md/MdVolumeUp";
import { MdHeadset } from "@react-icons/all-files/md/MdHeadset";
import { MdWifi } from "@react-icons/all-files/md/MdWifi";
import { MdSettings } from "@react-icons/all-files/md/MdSettings";
import {
  AudioHelpModalOverlay,
  AudioHelpModalCard,
  AudioHelpModalHeader,
  AudioHelpModalCloseButton,
  AudioHelpModalTitle,
  AudioHelpModalSubtitle,
  AudioHelpSection,
  AudioHelpSectionTitle,
  AudioHelpList,
  AudioHelpListItem,
  AudioHelpModalButtons,
  AudioHelpModalButton,
} from "./styled";

interface AudioHelpModalProps {
  isOpen: boolean;
  onClose: () => void;
  onGoBack: () => void;
  onTryAgain: () => void;
  translations: any;
}

const AudioHelpModal: React.FC<AudioHelpModalProps> = ({
  isOpen,
  onClose,
  onGoBack,
  onTryAgain,
  translations,
}) => {
  if (!isOpen) return null;

  // Validar que las traducciones estén disponibles
  if (!translations?.audioHelp) {
    return null;
  }

  // Extraer las traducciones
  const audioHelp = translations.audioHelp;
  const sections = audioHelp.sections;
  const buttons = audioHelp.buttons;

  return (
    <AudioHelpModalOverlay>
      <AudioHelpModalCard>
        <AudioHelpModalHeader>
          <AudioHelpModalCloseButton onClick={onClose}>
            <MdClose size={24} />
          </AudioHelpModalCloseButton>
          <AudioHelpModalTitle>{audioHelp.title}</AudioHelpModalTitle>
          <AudioHelpModalSubtitle>{audioHelp.subtitle}</AudioHelpModalSubtitle>
        </AudioHelpModalHeader>

        <AudioHelpSection>
          <AudioHelpSectionTitle>
            <MdVolumeUpIcon size={20} />
            {sections.volume?.title}
          </AudioHelpSectionTitle>
          <AudioHelpList>
            {sections.volume?.items?.map((item: string, index: number) => (
              <AudioHelpListItem key={index}>{item}</AudioHelpListItem>
            ))}
          </AudioHelpList>
        </AudioHelpSection>

        <AudioHelpSection>
          <AudioHelpSectionTitle>
            <MdHeadset size={20} />
            {sections.headphones?.title}
          </AudioHelpSectionTitle>
          <AudioHelpList>
            {sections.headphones?.items?.map((item: string, index: number) => (
              <AudioHelpListItem key={index}>{item}</AudioHelpListItem>
            ))}
          </AudioHelpList>
        </AudioHelpSection>

        <AudioHelpSection>
          <AudioHelpSectionTitle>
            <MdWifi size={20} />
            {sections.connection?.title}
          </AudioHelpSectionTitle>
          <AudioHelpList>
            {sections.connection?.items?.map((item: string, index: number) => (
              <AudioHelpListItem key={index}>{item}</AudioHelpListItem>
            ))}
          </AudioHelpList>
        </AudioHelpSection>

        <AudioHelpSection>
          <AudioHelpSectionTitle>
            <MdSettings size={20} />
            {sections.browser?.title}
          </AudioHelpSectionTitle>
          <AudioHelpList>
            {sections.browser?.items?.map((item: string, index: number) => (
              <AudioHelpListItem key={index}>{item}</AudioHelpListItem>
            ))}
          </AudioHelpList>
        </AudioHelpSection>

        <AudioHelpModalButtons>
          <AudioHelpModalButton variant="secondary" onClick={onGoBack}>
            {buttons.goBack}
          </AudioHelpModalButton>
          <AudioHelpModalButton variant="primary" onClick={onTryAgain}>
            {buttons.tryAgain}
          </AudioHelpModalButton>
        </AudioHelpModalButtons>
      </AudioHelpModalCard>
    </AudioHelpModalOverlay>
  );
};

export default AudioHelpModal;
